import React, { useState, useEffect } from 'react';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import Tooltip from '@mui/material/Tooltip';
import MouseIcon from '@mui/icons-material/Mouse';
import StorefrontIcon from '@mui/icons-material/Storefront';
import { Link } from 'react-router-dom';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

import ListItemAvatar from '@mui/material/ListItemAvatar';
import QueueOutlinedIcon from '@mui/icons-material/QueueOutlined';
import SettingsIcon from '@mui/icons-material/Settings';
import PowerSettingsNewSharpIcon from '@mui/icons-material/PowerSettingsNewSharp';
import CreateRoomForm from '../create-room/CreateRoomForm';
import Settings from '../settings/Settings';
import EventManager from '../../Util/EventManager';
import Avatar from '@mui/material/Avatar';

export default function BasePage({ menuOpen, onClose }) {
    const [createRoom, setCreateRoom] = useState(false);
    const [showSettings, setShowSettings] = useState(false);

    useEffect(() => {
        EventManager.reactCreateARoomEvent(() => {
            setCreateRoom(true);
        });
        return () => {
            EventManager.unsetCreateARoomEvent();
        };
    }, []);

    return (
        <>
            <Drawer open={menuOpen} onClose={onClose}>
                <List>
                    <Link to='/home' style={{ color: 'unset', textDecoration: 'unset' }}>
                        <ListItem>
                            <ListItemAvatar>
                                <Avatar src='/images/logo192.png' alt='VYU1 Logo' />
                            </ListItemAvatar>
                            <ListItemText
                                primary='VYU1'
                                primaryTypographyProps={{
                                    variant: 'h5'
                                }}
                            />
                        </ListItem>
                    </Link>
                    <Divider />
                    <ListItem button key='Subscription'>
                        <ListItemIcon>
                            <Tooltip title='Subscriptions'>
                                <StorefrontIcon />
                            </Tooltip>
                        </ListItemIcon>
                        <ListItemText primary='Subscription' />
                    </ListItem>
                    <ListItem button key='Create Room' onClick={() => setCreateRoom(true)}>
                        <ListItemIcon>
                            <Tooltip title='Create a Room'>
                                <QueueOutlinedIcon />
                            </Tooltip>
                        </ListItemIcon>
                        <ListItemText primary='Create Room' />
                    </ListItem>
                    <ListItem button key='Pointers'>
                        <ListItemIcon>
                            <Tooltip title='Pointers'>
                                <MouseIcon />
                            </Tooltip>
                        </ListItemIcon>
                        <ListItemText primary='Pointers' />
                    </ListItem>
                    <ListItem button key='Settings' onClick={() => setShowSettings(true)}>
                        <ListItemIcon>
                            <Tooltip title='Settings'>
                                <SettingsIcon />
                            </Tooltip>
                        </ListItemIcon>
                        <ListItemText primary='Settings' />
                    </ListItem>
                </List>
                <Divider />
                <List>
                    {['Log Out'].map((text) => (
                        <ListItem button key={text} onClick={() => EventManager.emitKillUser()}>
                            <ListItemIcon>
                                <Tooltip title='Log Out'>
                                    <PowerSettingsNewSharpIcon />
                                </Tooltip>
                            </ListItemIcon>
                            <ListItemText primary={text} />
                        </ListItem>
                    ))}
                </List>
            </Drawer>

            {/* Show the Create New Room Modal */}
            <CreateRoomForm
                open={createRoom}
                onClose={() => {
                    setCreateRoom(false);
                }}
            />

            {/* Show the Settings Modal */}
            <Settings
                open={showSettings}
                onClose={() => {
                    setShowSettings(false);
                }}
            />
        </>
    );
}
